module.exports = __webpack_public_path__ + "static/38-4c247303f6ba9c8b269a374ad6f8c2e6.jpg";